export { FormlyWrapperFieldset } from './fieldset';
export { FormlyWrapperLabel } from './label';
export { FormlyWrapperDescription } from './description';
export { FormlyWrapperValidationMessages } from './message-validation';
//# sourceMappingURL=wrappers.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ng-formly/lib/src/ui-bootstrap/src/wrappers/wrappers.js
// module id = 330
// module chunks = 3